<script setup>
import { computed } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import SchedulerPanel from 'dashboard/routes/dashboard/conversation/SchedulerPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

const activeTab = computed(() => {
  const {
    is_contact_sidebar_open: isContactSidebarOpen,
    is_scheduler_panel_open: isSchedulerPanelOpen,
  } = uiSettings.value;

  if (isSchedulerPanelOpen) {
    return 1;
  }

  if (isContactSidebarOpen) {
    return 0;
  }
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  if (
    isSmallScreen.value &&
    (uiSettings.value?.is_contact_sidebar_open ||
      uiSettings.value?.is_scheduler_panel_open)
  ) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
      is_scheduler_panel_open: false,
    });
  }
};
</script>

<template>
  <div
    id="conversation-sidebar"
    v-on-click-outside="() => closeContactPanel()"
    class="ltr:border-l rtl:border-r border-n-weak h-full overflow-hidden z-10 w-[360px] min-w-[360px] 2xl:min-w-[420px] 2xl:w-[420px] flex flex-col bg-n-surface-1"
    :class="[
      {
        'md:flex': activeTab !== null,
        'md:hidden': activeTab === null,
      },
    ]"
  >
    <div class="flex flex-1 overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
      <SchedulerPanel v-if="activeTab === 1" />
    </div>
  </div>
</template>
